import { useEffect } from 'react';
import useFetchRecordTypes from '../useFetchRecordTypes';
import useFetchProviders from '../useFetchProviders';
import useAssociationForm from '../addLocation/useAssociationForm';
import { AssociationDetailsViewModel } from '../../../Models/Association/association-details-viewmodels';

export default function useEditAssociations({
  associations,
  editMode,
  associationData,
}: {
  associations?: AssociationDetailsViewModel;
  associationData?: AssociationDetailsViewModel;
  editMode?: boolean;
}) {
  const { recordTypes } = useFetchRecordTypes();
  const { providers } = useFetchProviders();

  const { associationsForm } = useAssociationForm();

  useEffect(() => {
    if (editMode && associationData) {
      associationsForm.setValues({
        parentEntityId: associationData.parentEntityId ?? 0,
        entityAssociations:
          associationData.entityAssociations?.map((item) => ({
            id: item.id ?? 0,
            childEntityId: item.childEntityId ?? null,
            childEntityName: item.childEntityName ?? null,
            relationshipType: item.relationshipType ?? null,
            preferenceNotes: item.preferenceNotes ?? null,
            isBidirectional: item.isBidirectional ?? false,
            parentRoleType: item.parentRoleType ?? null,
            childRoleType: item.childRoleType ?? null,
            disabled: item.disabled ?? false,
            associationRecordTypes:
              item.associationRecordTypes?.map((record) => ({
                id: record.id ?? 0,
                dateFrom: record.dateFrom ?? null,
                dateTo: record.dateTo ?? null,
                custodianProviderId: record.custodianProviderId ?? null,
                custodianProviderName: record.custodianProviderName ?? null,
                recordTypeId: record.recordTypeId ?? null,
                recordTypeName: record.recordTypeName ?? null,
                disabled: record.disabled,
              })) ?? [],
          })) ?? [],
      });
    }
  }, [editMode, associationData]);

  return {
    associationsForm,
    recordTypes,
    providers
  };
}
